<article>
  <img src="/assets/logos/logo-get-covered.svg" alt="GetCovered">
  <h1>We’ll be right back!</h1>
  <div>
    <p>Sorry for the inconvenience, but we're performing some maintenance at the moment.</p>
    <p>&mdash; The GetCovered Team</p>
  </div>
</article>
